import { methods, request } from "./base";

const journeyApis = {
  getCycles: async (data?: any) => {
    const route = "/patient_visit/get_patient_visit_details";
    return await request({
      method: methods.POST,
      route,
      priv: true,
      payload: data,
    });
  },
  updateAttendance: (data?: any) => {
    const route = "/patient_visit/update_patient_visit";
    return request({
      method: methods.POST,
      route,
      payload: data,
    });
  },
  getCycleDocuments: (data?: any) => {
    // const route = "/healthcoach/get_records";
    const route = "/patient/get_records";
    return request({
      method: methods.POST,
      priv: true,
      payload: data,
      route,
    });
  },
  updatePatientVisit: (data: any) => {
    const route = "/patient_visit/update_patient_visit";
    return request({
      method: methods.POST,
      priv: true,
      payload: data,
      route,
    });
  },
  createFirstCycle: (data: any) => {
    const route = "/patient_visit/schedule_patient_visit";
    return request({
      method: methods.POST,
      priv: true,
      payload: data,
      route,
    });
  },
  getDrugs: (data: any) => {
    const route = "/gfc/config/therapy_drugs";
    return request({
      method: methods.GET,
      priv: true,
      payload: data,
      route,
    });
  },
};

export default journeyApis;
